import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

const DRIVESFI_URL = "https://drivesfi.com";
const DRIVESFI_ORIGIN = new URL(DRIVESFI_URL).origin;
const HEIGHT_MESSAGE_TYPE = "drivesfi:document-height";
const MIN_FRAME_HEIGHT = 320;
const MAX_FRAME_HEIGHT = 50_000;

export default function DrivesFi() {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(null);

  useEffect(() => {
    const handleHeightMessage = (event) => {
      const iframeWindow = iframeRef.current?.contentWindow;
      const height = event.data?.height;

      if (
        event.origin !== DRIVESFI_ORIGIN ||
        event.source !== iframeWindow ||
        event.data?.type !== HEIGHT_MESSAGE_TYPE ||
        typeof height !== "number" ||
        !Number.isFinite(height) ||
        height < MIN_FRAME_HEIGHT ||
        height > MAX_FRAME_HEIGHT
      ) {
        return;
      }

      const nextHeight = Math.ceil(height);
      setIframeHeight((currentHeight) =>
        currentHeight === nextHeight ? currentHeight : nextHeight,
      );
    };

    window.addEventListener("message", handleHeightMessage);

    return () => window.removeEventListener("message", handleHeightMessage);
  }, []);

  return (
    <>
      <Helmet>
        <title>DrivesFi</title>
      </Helmet>

      <section
        aria-label="DrivesFi"
        className="drivesfi-embed"
        style={{
          width: "100%",
        }}
      >
        <iframe
          ref={iframeRef}
          src={DRIVESFI_URL}
          title="DrivesFi website"
          loading="eager"
          referrerPolicy="strict-origin-when-cross-origin"
          scrolling={iframeHeight === null ? "auto" : "no"}
          style={{
            border: 0,
            display: "block",
            height: iframeHeight === null ? undefined : `${iframeHeight}px`,
            minHeight: "720px",
            width: "100%",
          }}
        />
        <noscript>
          <p>
            JavaScript is required to display DrivesFi here. Visit{" "}
            <a href={DRIVESFI_URL}>drivesfi.com</a> instead.
          </p>
        </noscript>
      </section>
    </>
  );
}
